var _defs, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChadwave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 603.03 425.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11 {\n        stroke-width: 3px;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-7, .cls-8, .cls-9, .cls-10 {\n        stroke-linecap: round;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11 {\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-4, .cls-11 {\n        stroke: #b3b3b3;\n      }\n\n      .cls-1, .cls-11 {\n        fill: #b3b3b3;\n      }\n\n      .cls-2, .cls-9 {\n        stroke: #e9e9e9;\n      }\n\n      .cls-2, .cls-10 {\n        fill: none;\n      }\n\n      .cls-3 {\n        stroke: #a09e9f;\n      }\n\n      .cls-3, .cls-7 {\n        fill: #a1a0a0;\n      }\n\n      .cls-4, .cls-12 {\n        fill: #b2b2b2;\n      }\n\n      .cls-5 {\n        stroke: #626464;\n      }\n\n      .cls-5, .cls-13 {\n        fill: #626363;\n      }\n\n      .cls-12, .cls-13 {\n        stroke-width: 0px;\n      }\n\n      .cls-6 {\n        fill: #d4d4d4;\n        stroke: #d4d4d4;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-7 {\n        stroke: #a09f9f;\n      }\n\n      .cls-8 {\n        fill: #494849;\n      }\n\n      .cls-8, .cls-10 {\n        stroke: #484848;\n      }\n\n      .cls-9 {\n        fill: #e9e9e9;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M258.2,82.68l-34.95,124.98-10.12-1.8s-44.33,25.86-59.16,40.7c-14.84,14.84-14.79,8.76-22.27,21.99s-29.34,109.69-29.34,109.69l79.94-39.06,16,60.69,109.76,24.75,173.26-23.82-33.53-135.42-83.58-30.99,3-87.36-13.14-49.29-76.15-38.85-19.7,23.78h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M82.17,212.3l-27.78,93.97,27.58,66.28,20.39,5.68,33.7-119.18,9.38-78.49,21.73-6.17,18.4-15.32,19.47-14.49-4.9-6.48-13.47,2.49s-11.22,5.72-14.3,2.12l4.16-25.39,16.27-36.63-5.7-9.97-22.21,34.02,5.01-22.05s6.84-19.43,5.64-22.08-7.57-5.47-7.57-5.47l-13.42,24.93s.96-10.64,1.15-12.85,3.93-11.69,3.93-11.69c0,0-7.06-5.08-9.62-4.12s-9.84,16.24-9.84,16.24c0,0-3.65,18.85-5.95,21.34s-10.93,13.62-10.93,13.62c0,0-3.26-25.5-3.26-27.61s.49-18.32.49-18.32l-8.26,1.06-7.33,23.71-10.51,70.62.58,17.46-12.83,42.75v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M363.8,145.71s-9.04,6.06-12.86,6.97-5.06,11.54-5.06,11.54c0,0-2.8,20.89-4.1,23.24-1.3,2.35-19.02,23.72-19.02,23.72l-9.83,3.71-25.47-7.72-17.9-19.55-4.53,17.15s11.39,27.44,17.8,30.02,18.65,7.25,27.62,8.01c8.97.76,14.45-1.03,14.45-1.03l-6.78,23.62s-8.05,15.66-6.2,20.55l6.75-5.62,17.04-3.12,23.79-3.89,13.1-84.27,1.93-54.55-18.68-41.66-45.02-13.92-19.17,4.94-28.87,36.93s7.07.02,13.09-2.69c6.02-2.71,25.32-24.22,34.52-26.13,5.07-1.05,10.25-.46,16.07,4,1.23-.22,10.55-1.08,15.65,2.61,6.25,4.52,12.33,26.38,12.33,26.38l9.34,20.78v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M384.11,267.58l25.54-5.72s18.92.15,22.07,2.86,18.93,32.58,21.7,46.48c3.17,15.85-.93,44.15,3.9,56.95s18.32,20.36,18.32,20.36l16.47-4.9,6.64-8.37-15.77-50.06-11.53-32.61-5.78-11.85-10.88-14.24-13.79-10.48-24.04-10.24-32.85-11.37v33.19h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M307.18,318.94s-1.23,32.33,6.57,56.43c2.69,8.32-8.83,5.9-8.83,5.9l-2.97-9.83.33-42.37,4.9-10.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M277.06,208.86s-.22,35.85-13.93,46.01-7,14.17,0,15.92c21.87,5.47,21.87,9.51,21.87,9.51l-29.46-9.59-22.62-11.86,4.09-35.51,40.05-14.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M440.18,316.5s-4.65,26.72,2.19,36.66c8.92,12.97,12.38-9,12.38-9l26.56,46.66-72.27-2.3-2.99-5.99,18.91-15.44,15.22-50.59h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M287.78,174.87s8,12.17,18.43,14.44c10.43,2.28,26.26-7.62,28.36-10.03s-2.86-3.25-2.86-3.25c0,0-24.83-3.74-34.78-3.02s-9.15,1.86-9.15,1.86h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M189.49,219.13s7.59.77,9.53,3.64,1.03,16.57,8.69,26.1c2.98,3.71,8.46,6.55,8.46,6.55l-3.94-49.02-22.74,12.72h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M126.47,179.54s-3.02,40.4-7.17,52.21-9.09,40.13-10.03,56.18c-.94,16.06-1.62,26.84-1.62,26.84,0,0,8.43-39.63,16.23-42.92,7.8-3.29,9.52,45.38,5.82,55.77s-10.1,22.66-10.1,22.66c0,0,25.29-23,26.71-31.33s4.91-23.63-6.26-48.26l-4.97-16.5,10.33-73.62s-16.72,3.56-18.96-1.03h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M87.79,376.14s11.61,3.54,20.86-.98,92.5-48.24,92.5-48.24l13.33-32.94s-14.17,14.59-25.59,19.94-48.48,6.46-48.48,6.46c0,0-33.35,54.28-52.62,55.76h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M124.03,119.71s5.4,7.73,14.3,7.56,19.69,3.01,19.69,3.01c0,0-10.74,19.22-19.69,25.24s-13.1,8.73-13.1,8.73c0,0,8.72-13.15,7.47-18.62s-8.67-25.92-8.67-25.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M177.27,339.44l9.54,40.34s11.01-2.16,13.1-.81-3.01-33.6-1.06-41.49,6.18-21.6,6.18-21.6l-27.77,23.56h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M146.71,253.23s16.68-5.51,27.06-5.71c9.4-.18,15.11-.45,15.11-.45,0,0-10.44-5.61-20.88-3.92s-21.29,10.09-21.29,10.09h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M220.17,112.3l8.33,34-8.33,12.21-11.16,1.69-4.65-1.68,4.29,3.81,12.61,4.59-13.84,11.8-11.33,17.74,4.09,11.52s1.83-14.55,10.24-17.68c0,0-3.03,16.54.79,22.18,3.82,5.64,10.22,25.13,10.22,25.13,0,0,26.63.03,29.62-18.47,2.99-18.5,3.03-50.62,3.03-50.62l8.46-13.55,12.16-1.6-10.96-5.5-.44-24.74s4.57-8.43,6.01-11.71,6.64-5.06,6.64-5.06c0,0,9.31-2.28,13.51-10.08,4.2-7.81,7.21-23.58,7.21-23.58l26.13,4.92,35.46,13.79s-2.33,17.86,3,25.05,10.53,11.44,19.56,14,29.14,3.84,23.54-8.58c-5.61-12.43-11.52-48.53-13.69-54.44-2.17-5.9-17.75-24.94-27.78-24.48-10.03.47-31.88,4.23-31.88,4.23,0,0-11.51-11.14-26.76-13.61s-25.82,7.29-37.35,19.63,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M352.13,209.18s-17.16,21.15-18.25,35.87c-1.23,16.69,8.99,9.5,8.99,9.5l5.83-5.22,13.12,23.11,17.2-13.59s14.9-15.8,17.76-23.88c2.86-8.08,2.28-21.22,2.28-21.22l-24.98-34.31-21.96,29.74h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M311.05,34.71s10.78,7.55,11.07,12.65-.36,6.11-.36,6.11c0,0-4.52-3.56-11.24-4.71s-9.61-.59-9.61-.59c0,0,6.75.49,11.51,4.49,4.76,4,9.85,10.69,9.35,17.1-.51,6.41-.8,7.44-.8,7.44,0,0-14.22-9.78-18.74-8.53-4.97,1.38-5.57,15.78-5.57,15.78,0,0,15.74-.98,19.78-.24s12.68,5.1,12.68,5.1c0,0,11.58-2.05,21.67,2.77,3.42,1.63,5.08.73,5.08.73,0,0,3.1-14.31-1.03-14.74s-15.94,1.92-15.94,1.92l-6.02,2.05s5.06-6.31,6.17-10.69c1.11-4.37,5.75-11.97,14.24-13.3s12.09.08,12.09.08c0,0-7.68-8.6-18.88-6.45-3.25.62-4.91,1.38-4.91,1.38,0,0,3.16-5.3,9.96-7.24,11.55-3.29,12.17-2.78,12.17-2.78l-30.97.92-21.68-9.25h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M391.19,69.23s4.31,14.89-.93,11.68-7.65-7.99-14.85-11.12c0,0,6.93,8.01,6.6,17.82s1.59,29.37,1.59,29.37c0,0,6.54,5.23,14.52,6.43,7.99,1.2-1.77,5.03-1.77,5.03,0,0-14.1,7.06-19.69,1.39-5.58-5.67-4.46,8.16-4.46,8.16,0,0,4.14,13.84-6.78,23.32,0,0-1.48,5.13-7.1,5.19s-8.14.58-8.14.58c0,0,9.35,5.92,12.39,6.31s-.06,17.5-.06,17.5l-18.95,9.93-1.58,23.03h0s-1.01.12,9.81-10.29c10.82-10.4,14.46-16.37,19.45-30.45,0,0,10.36,14.83,7.15,26.83s-10.24,19.4-10.24,19.4c0,0,13.58-1.4,20.4-12.75,2.29-3.8,3.57-11.61,3.57-11.61,0,0,4.07,4.17,6.19,10.69,1.98,6.1,3.15,7.23,3.15,7.23,0,0,5.85,7.48,6.45,10.41,1.08,5.24-4.13,13.25-4.13,13.25,0,0,9.73-13.26,8.58-20.52-1.48-9.37-14.78-33.96-14.78-33.96,0,0,3.88,5.88,10.48,5.06s12.44-4.42,12.44-4.42c0,0-11.76,3.39-17.37-3.24-5.21-6.15-3.74-16.13-.39-23.42,3.34-7.29,8.36-6.06,13.04-18.41,7.55-19.91-10.13-31.16-10.13-31.16,0,0,5.98-15.01-4.58-27.06-9.49-10.82-8.49-16.85-9.9-20.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M350.68,249.92s6.01,12.91,16.15,20.74c3.22-.32,14.35-8.65,14.92-13.98,1.05-9.76,14.41-17.84,14.41-17.84,0,0-9.33,11.03-10.28,17.06s1.57,23.55-15.29,30.03c-18.26,7.02-22.12,2.1-22.12,2.1,0,0,10.32-5.59,12.54-12.98,2.23-7.39-7.19-11.2-9.42-19.41-.91-3.35-.92-5.72-.92-5.72h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M335.29,239.79s.33,6.72,2.08,10.71c1.73,3.93,6.39,5.41,6.39,5.41l2.73,8.5s-11.04-6.17-11.41-10.05.2-14.57.2-14.57h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M209.73,201.32s5.69,8.96,11.22,17.65c5.01,7.89-1.51,16.86-1.51,16.86,0,0,19.17.33,25.22-15.61,2.66-7,.44-26.61,7.84-36.64,3.72-5.05,6.95-10.16,6.95-10.16l11.93,16.71-4.71,22.15s3.55,30.31-7.55,34.26c-11.1,3.96-10.28,3.08-10.28,3.08,0,0,10.94-12.01,1.29-17.84-6.94-4.19,0,0,0,0,0,0-5.71,9.64-12.61,13.67-6.9,4.02-6.76,11.14-5.27,15.2s5.17,7.75,5.17,7.75c0,0-17.57-4.21-21.44-10.07s-6.45-15.15-2.32-29.63c4.13-14.48-6.18-19.09-4.43-28.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M221.26,169.9s13.35-6.19,17.99-8.39c5.38-2.55,9.37-15.46,9.37-15.46,0,0,4.98,9.09,12.38,11.32,2.1.63-5.82,23.42-6.09,25.81-.53,4.73,4.48-10.79-11.01-9.65-11.49.85-21.3,15.03-21.3,15.03,0,0,1.6-10.63,5.53-16.66,0,0-4.37-.85-9.99,1.19-7.16,2.59-8.42,4.52-8.42,4.52l11.53-7.72h0Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "262.89 58.4 243.99 74.73 241.69 87.18 226.23 96.21 220.31 111.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M324.6,172.95s1.58,4.95.51,7.51c-1.07,2.56-4.18,7.03-4.18,7.03,6.89,1.76,16-15.01,16-15.01l-12.33.47h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M299.58,169.91s-4.04,2.41-3.95,5.19,1.86,9.19,1.86,9.19l-11.13-15.04,13.21.67h0Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "220.17 112.3 232.85 91.27 241.52 85.43 256.96 61.56 267.67 68.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M419.3,114.98s8.68,13.27,9.01,16.99,1.49,10.63,1.49,10.63c0,0,8.61-18.62,11.35-19.09s5.55-1.35,5.55-1.35c0,0-6.34-8.15-6.73-11.18s-1.18-11.26-1.18-11.26c0,0-15.01,14.55-17.14,14.39s-2.35.86-2.35.86h0Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M364.65,161.83c2.35-9.29,7.53-19.75,7.53-19.75,0,0,.48-.8-1.63-7.3l.81-9.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M305.07,212.3s10.35,2.31,13.52,1.06c12.04-4.76,43.67-23.43,43.67-23.43,0,0-.09-8.15.58-16.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M342.56,202.02s-1.15,7.84-1.15,13.73v8.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M317.5,268.55c1.26-8.99,14.19-47.94,14.19-47.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M311.93,285.93s9.39-7.55,11.7-7.55,31.44-3.1,35.89-5.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M409.05,262.7c-8.39,3.27-21.87,5.36-21.87,5.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M397.61,238.94s40.7,11.81,48.9,19.86,17.31,9.35,30.32,45.13,20.49,68.63,20.49,68.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M441.06,308.16s-9.76,49.44-17.89,59.84-20.82,15.61-20.82,15.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M306.52,317.71s-5.06,13.16-5.21,21.7-.05,33.15-.05,33.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M311.72,171.64s10.38-.05,17.28-.05,12.42-1.78,12.42-1.78c0,0-8.14,13.31-14.99,16.78s-11.98,4.08-17.76,3.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M319.63,178.73s8.09-.49,12.29-2.81,7.11-5.36,7.11-5.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M319.63,178.73s8.09-.49,12.29-2.81,7.11-5.36,7.11-5.36"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 306.19,
    y1: 197.91,
    x2: 309.49,
    y2: 198.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M317.72,161.41s1.47.15,1.92,1.09"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 306.19,
    y1: 197.91,
    x2: 302.9,
    y2: 197.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M264.65,145.63c.71-9.57-.9-21.15-.9-21.15,0,0-.2-.91,3.85-6.41l2.2-9.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M305.07,212.3s-10.55-1.08-13.16-3.27c-9.92-8.32-34.03-36.03-34.03-36.03,0,0,2.71-7.84,4.66-15.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M272.95,190.32s-.54,8.32-2.33,13.94-3.7,9.47-3.7,9.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M275.13,212.3s5.08,44.1,6.34,53.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M290.58,285.93s-9.39-7.55-11.7-7.55-35.66-10.95-43.76-17.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M311.61,171.63s-10.49-2.22-17.37-1.77c-6.89.46-12.72-2.55-12.72-2.55,0,0,6,8.4,11.41,13.86s10.08,7.66,15.73,8.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M301.78,178s-7.96-1.55-11.82-4.4-6.45-3.78-6.45-3.78"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 306.19,
    y1: 197.91,
    x2: 302.9,
    y2: 197.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M309.15,160.03s-1.45-.33-2.16.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M319.76,121.68c-1.11-.18-3.86.04-4.65,1.34s-7.24,10.77-7.24,10.77c0,0-1.71,3.9-6.12,3.84s-19.62-2.52-25.4-6.1c-5.78-3.57-4.94-10.8-4.94-10.8l.37-10.94,10.76-5.05s24.33,5.59,28.7,8.28c4.37,2.69,4.85,3.96,4.85,3.96,0,0,1.45-.96,4.51-.47s4.13,1.87,4.13,1.87c0,0,.86-1.06,5.85-2.22s29.85,1.21,29.85,1.21l8.61,8.19-3.1,10.49s-1.48,7.12-8.1,8.68-21.83-.9-26.03-2.24-4.59-5.58-4.59-5.58c0,0-3.13-11.03-3.47-12.51s-2.87-2.56-3.99-2.74v.02Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 306.19,
    y1: 197.91,
    x2: 309.49,
    y2: 198.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M209.21,207.99s-13.83,5.7-23.25,14.21c0,0-20.06,11.85-26.75,19.15s-20.89,18.53-20.89,18.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M202.73,325.23s-33.17,20.12-46.67,27.75-39.9,18.78-47.53,24.06-25.01-1.6-26.56-4.48-29.14-57.12-27.59-68.58c1.55-11.46,39.05-123.88,39.98-134.15s-1.24-12.61.93-24.15c2.17-11.54,4.96-35.59,4.96-35.59,0,0,4.03-25.23,4.96-30.19s6.2-14.88,5.89-22.93c0,0,7.75-1.55,9.92,0s-.31,19.84.31,24.17,2.56,22.23,2.56,22.23c0,0,10.46-12.93,12.63-19.13s3.72-17.05,3.72-17.05c0,0,6.51-15.81,10.85-16.12s8.99,4.96,8.99,4.96c0,0-3.72,10.24-5.27,15.82s-6.82,30.18-7.44,32.9,3.1,5.11,3.1,5.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M146.84,180.63s-10.11,70.11-10.11,76.31,7.83,18.59,11.41,38.15c3.58,19.56-2.61,30.98-7.16,34.24s-5.88,8.15-5.88,8.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M119.3,176.31s10.06,4.25,19.85,4.25,22.04-4.82,26.93-4.5,16.96-14.61,20.87-16.11,19.89-14.28,19.89-14.28c0,0-3.71-7.56-6.7-7.56s-10.14,0-13.47,2.49-5.99,3.33-5.99,3.33l-8.31-1.21s4.49-18.08,4.66-23.9,8.48-18.62,10.31-22.28,7.41-15.3,6.12-18.62-6.45-8.81-6.45-8.81c0,0-11.8,18.13-13.13,20.37s-8.98,15.27-8.98,15.27l-2.16,5.33s5.74-23.75,6.82-26.5c.49-1.25,7.81-18.95,6.82-22.78s-8.98-6.65-8.98-6.65c0,0-6.82,17.46-9.31,21.11s-5.49,12.64-5.49,12.64c0,0-1.9,8-3.07,10.99s-2.16,5.86-2.16,5.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M123.89,118.83s2.46,16.53,7.31,26.42c2.82,5.75-7.31,18.99-7.31,18.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M177.27,340.53s2.63,6.9,2.63,12.17,3.95,16.79,3.95,16.79"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Hair"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M349.09,212.62s-13.64,18.35-15.1,31.57c-1.32,12,4.84,20.16,15.93,22.09,0,0-5.58-5.48-4.77-10.43s5.06-7.32,5.06-7.32c0,0-1.39,4.17,1.84,11.34,3.23,7.16,9.91,11.42,7.12,17.81-2.79,6.38-13.78,10.78-13.78,10.78,0,0,25.24,7.44,36.06-10.23,8.27-13.51,3.11-17.22,6.48-25.32,3.37-8.09,11.33-9.93,13.57-30.02,0,0,14.52,15.6-.91,25.87,0,0,10.3-1.87,12.99-17.61,2.69-15.75-9.35-30.01-17.74-39.18,0,0,7.47,8.07,16.98,5.22s13.51-9.74,13.51-9.74c0,0-10.54,7.48-18.3,2.93-7.77-4.55-12.04-16.62-.76-28.64s13.6-21.81,9.75-31.89c-3.85-10.09-10.83-12.27-10.05-17.08s3.29-8.18-.74-15.66c-4.03-7.48-11.76-16.34-13.34-23.88-3.95-18.85-20.93-33.63-40.45-31.62-14.33,1.47-20.13,2.77-20.13,2.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M381.86,107.79c-1.98,20.15,20.12,15.51,20.12,15.51-16.57,13.2-34.09,3.19-42.41-7.67s-1.04-33.59-2.5-36.13-9.69-3.3-17.56-.97-14.65,11.74-14.65,11.74c0,0,7.74-2.61,15.96-.65s14.16,6.71,14.16,6.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M370.62,145.67s-1.67,13.43-7.72,17.8c-6.06,4.37-17.21.4-17.21.4,0,0,9.43,9.21,19,9.07,7.64-.11,15.29-7.57,15.29-7.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M263.21,198.7s7.15,21.72,4.35,34.73c-2.54,11.81-10.96,17.6-22.09,15.93,0,0,7.02-3.44,7.82-8.39s-2.49-8.54-2.49-8.54c0,0,0,4.4-5.33,10.18s-13.01,7.71-12.38,14.65,9.66,14.58,9.66,14.58c0,0-26.3-.92-30.98-21.1-3.58-15.43,2.49-17.32,1.85-26.07-.64-8.74-7.61-13-3.39-32.77,0,0-14.46,8.89-6.84,23.12,0,0-9.65-3.31-7.23-19.1s18.35-25.52,29.21-31.57c0,0-9.64,5.3-17.76-.41-8.13-5.71-8.35-11.85-8.35-11.85,0,0,6.25,8.76,15.05,6.9s16.67-11.96,9.77-26.93-6.02-24.99.82-33.34c6.84-8.35,14.15-8.22,14.93-13.03s-.54-8.8,5.65-14.63,16.32-11.78,20.2-18.44c9.71-16.64,30.48-25.3,48.37-17.22,13.13,5.93,18.22,8.99,18.22,8.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M265.23,88.89c-4.49,19.75-23.98,8.36-23.98,8.36,11.55,17.76,31.33,13.8,42.66,6.13,11.33-7.67,11.6-31.54,13.79-33.49s10.24-.07,16.97,4.62c6.73,4.69,10.19,15.77,10.19,15.77,0,0-6.52-4.92-14.94-5.66s-15.55,1.89-15.55,1.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M263.93,128.38s-2.66,13.27,1.71,19.33c4.37,6.06,16.2,5.82,16.2,5.82,0,0-11.85,5.76-20.9,2.6-7.22-2.52-12.12-12.01-12.12-12.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M274.89,114.49s-2.62,11.67,2.42,14.7c5.05,3.03,13.72,4.31,13.72,4.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M328.04,126.78s1.17,9.75,4.07,12.19,16.1,3.01,16.1,3.01"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 345.34,
    y1: 119.71,
    x2: 330.55,
    y2: 134.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 355.9,
    y1: 121.19,
    x2: 337.76,
    y2: 139.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 290.12,
    y1: 110.09,
    x2: 275.33,
    y2: 124.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 298.17,
    y1: 112.88,
    x2: 280.74,
    y2: 130.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M439.42,95.19s-5.51,14.67-21.67,19.33c0,0,12.63,9.47,11.5,32.51,0,0,7.9-25.46,20.82-25.46,0,0-14.62-7.54-10.65-26.39h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChadwave);
export default __webpack_public_path__ + "static/media/chadwave.705aae87fbafbbe95756508a264c1a91.svg";
export { ForwardRef as ReactComponent };